// extracted by mini-css-extract-plugin
export default {"list":"fpvbn2PGmRltucLkE6kb","formItem":"vL_Jnd1X3u1SQelS9kdm","qrHolder":"dByz7CmA7e0oVn66MyEo"};